import React from 'react';
import SvgIcon from '../SvgIconWrapper';

interface LBeamIconProps {
  size?: number;
  color?: string;
}

const LBeamIcon: React.FC<LBeamIconProps> = (props) => (
  <SvgIcon {...props} className="sx-icon-lbeam">
    {
      <path d="M5.435 2.863s1.153-0.185 1.153 0.219v16.109c0 0.525 0.482 0.728 1.007 0.728h11.641c0.065 0 0.065 1.148 0 1.148h-13.802z"></path>
    }  </SvgIcon>
);

export default LBeamIcon;
